import { render, staticRenderFns } from "./LongestUnresolvedFindings.vue?vue&type=template&id=434ffe7e"
import script from "./LongestUnresolvedFindings.vue?vue&type=script&lang=js"
export * from "./LongestUnresolvedFindings.vue?vue&type=script&lang=js"
import style0 from "./LongestUnresolvedFindings.vue?vue&type=style&index=0&id=434ffe7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports